import { useHistory } from 'react-router'
import { VoucherForm } from 'domains/voucher'
import { ALERT_TYPES } from 'constants/alert-constants'
import TitlePage from 'components/atoms/title-page'
import CustomerVoucherRulesApiV2 from 'api/v2/admins/customer-voucher-rules-api-v2'
import PropTypes from 'prop-types'

const propTypes    = {
  pageUtils: PropTypes.shape({
    setAlertMsg    : PropTypes.func,
    setApiErrorMsg : PropTypes.func
  })
}
const defaultProps = {
  pageUtils: {
    setAlertMsg    : () => {},
    setApiErrorMsg : () => {}
  }
}

const VoucherCreatePage = ({ pageUtils }) => {

  const history = useHistory()

  const handleSubmitForm = async (values) => {
    await CustomerVoucherRulesApiV2.create(values)
      .then(() => {
        pageUtils.setAlertMsg('Successfully created voucher.', ALERT_TYPES.SUCCESS)
        history.goBack()
      })
      .catch((error) => pageUtils.setApiErrorMsg(error.response.data))
  }


  return (
    <>
      <TitlePage mainTitle='Create Voucher'/>
      <VoucherForm
        onSubmit={ handleSubmitForm }
      />
    </>
  )
}

VoucherCreatePage.propTypes    = propTypes
VoucherCreatePage.defaultProps = defaultProps

export default VoucherCreatePage
